<template>
    <layout :title="organisation ? organisation.data.name : 'Organisatie'">
        <div v-if="!organisation" class="p-4 text-center">
            <h1 class="text-2xl font-bold text-gray-900">{{ message }}</h1>
        </div>
        <div v-if="organisation" to="modal">
            <transition enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
                leave-to-class="opacity-0">
                <modal v-if="showCreateAttendeeModal" title="Succes" message="Deelnemer succesvol toegevoegd"></modal>
            </transition>
            <transition enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
                leave-to-class="opacity-0">
                <modal v-if="showCreateCampaignModal" title="Gestart" message="Campaigne succesvol gestart"></modal>
            </transition>
        </div>

        <div to="modal">
            <transition enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
                leave-to-class="opacity-0">
                <modal v-if="successModal" title="Succes" message="Campagne is succesvol aangemaakt"></modal>
            </transition>
        </div>

        <transition enter-active-class="transition duration-300 ease-out transform"
            enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
            leave-to-class="opacity-0">
            <div v-if="showGroupModal" class="fixed inset-0 z-20 flex items-center justify-center bg-gray-500 bg-opacity-75">
                <div class="bg-white rounded-lg shadow-xl max-w-sm w-full mx-4">
                    <div class="px-6 py-4 border-b border-gray-200">
                        <h3 class="text-lg font-medium leading-6 text-gray-900">
                            Nieuwe groep aanmaken
                        </h3>
                    </div>
                    <div class="px-6 py-4">
                        <label for="group_name" class="block text-sm font-medium text-gray-700 mb-1">
                            Naam van de groep
                        </label>
                        <input
                            id="group_name"
                            type="text"
                            v-model="newGroupName"
                            :class="[
                                'block w-full rounded-md shadow-sm sm:text-sm',
                                groupErrors.name ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-lightblue-500 focus:border-lightblue-500'
                            ]"
                            placeholder="Bijvoorbeeld: Team A"
                        />
                        <p v-if="groupErrors.name" class="mt-2 text-sm text-red-600">
                            {{ groupErrors.name }}
                        </p>
                    </div>
                    <div class="px-6 py-4 bg-gray-50 flex justify-end space-x-3 rounded-b-lg">
                        <button
                            type="button"
                            @click="closeGroupModal"
                            class="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500"
                        >
                            Annuleren
                        </button>
                        <button
                            type="button"
                            @click="createGroup"
                            :disabled="!newGroupName || !newGroupName.trim()"
                            :class="[
                                'inline-flex justify-center px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2',
                                (!newGroupName || !newGroupName.trim())
                                    ? 'bg-lightblue-300 cursor-not-allowed'
                                    : 'bg-lightblue-600 hover:bg-lightblue-500 focus:ring-lightblue-500'
                            ]"
                        >
                            Opslaan
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <transition enter-active-class="duration-300 ease-out" enter-class="opacity-0" enter-to-class="opacity-100"
            leave-active-class="duration-200 ease-in" leave-class="opacity-100" leave-to-class="opacity-0">
            <div v-show="createCampaignModal" class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <div class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div
                                    class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                                    <!-- Heroicon name: exclamation -->
                                    <svg class="w-6 h-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-headline">
                                        Campagne starten voor {{ organisation ? organisation.data.name : 'Organisatie' }}
                                    </h3>

                                    <div v-if="startCampaignStep == 1">
                                        <div class="mt-2">
                                            <p class="text-sm text-gray-500">
                                                Een campagne wordt gestart voor alle deelnemers in de organisatie.
                                                Gebruiker klik notificaties om een melding te krijgen van e-mail kliks.
                                            </p>
                                            <div class="mt-4">
                                                <label for="attempts_per_user"
                                                    class="block text-sm font-medium text-gray-700">E-mails per
                                                    gebruiker*</label>
                                                <div class="mt-1">
                                                    <input required type="number" id="attempts_per_user"
                                                        v-model="startForm.attempts_per_user"
                                                        @input="validateForm"
                                                        :class="{ ' border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': campaignErrors.attempts_per_user }"
                                                        class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                                                        placeholder="10">
                                                </div>
                                                <p v-if="campaignErrors.attempts_per_user" class="mt-2 text-sm text-red-600"
                                                    id="attempts_per_user-error">{{ campaignErrors.attempts_per_user }}</p>
                                                <p v-else class="mt-2 text-sm text-gray-500"
                                                    id="attempts_per_user-description">Aantal e-mail wordt verspreid
                                                    over de gehele campagne duur.</p>
                                            </div>

                                            <div class="mt-4">
                                                <label for="click_notification"
                                                    class="block text-sm font-medium text-gray-700">Klik notificatie
                                                    naar</label>
                                                <div class="mt-1">
                                                    <input type="text" id="click_notification"
                                                        v-model="startForm.click_notification"
                                                        :class="{ ' border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': campaignErrors.click_notification }"
                                                        class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                                                        placeholder="test@test.nl, test2@test.nl">
                                                </div>
                                                <p v-if="campaignErrors.click_notification" class="mt-2 text-sm text-red-600"
                                                    id="click_notification-error">{{ campaignErrors.click_notification }}</p>
                                                <p v-else class="mt-2 text-sm text-gray-500"
                                                    id="click_notification-description">Komma gescheiden e-mail
                                                    adressen.</p>
                                            </div>

                                            <div class="mt-4">
                                                <label for="start_at"
                                                    class="block text-sm font-medium text-gray-700">Campagne start
                                                    op*</label>
                                                <div class="mt-1">
                                                    <input required type="date" id="start_at" v-model="startForm.starting_at"
                                                        @change="handleDateValidation('starting_at')"
                                                        :min="minDate"
                                                        @input="validateForm"
                                                        @blur="validateForm"
                                                        :class="{ ' border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.starting_at || campaignErrors.starting_at }"
                                                        class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                                                    >
                                                </div>
                                                <p v-if="campaignErrors.starting_time || campaignErrors.finished_time"
                                                    class="mt-2 text-sm text-red-600" id="timeblock-error">
                                                    {{ campaignErrors.starting_time || campaignErrors.finished_time }}</p>

                                                <p v-if="campaignErrors.starting_at" class="mt-2 text-sm text-red-600"
                                                    id="start_at-error">{{ campaignErrors.starting_at }}</p>
                                            </div>

                                            <div class="mt-4">
                                                <label for="finished_at"
                                                    class="block text-sm font-medium text-gray-700">Campagne eindigt
                                                    op*</label>
                                                <div class="mt-1">
                                                    <input required type="date" id="finished_at" v-model="startForm.finished_at"
                                                        @change="handleDateValidation('finished_at')"
                                                        :min="startForm.starting_at || minDate"
                                                        @input="validateForm"
                                                        @blur="validateForm"
                                                        :class="{ ' border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.finished_at || campaignErrors.finished_at }"
                                                        class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                                                    >
                                                </div>
                                                <p v-if="campaignErrors.finished_at" class="mt-2 text-sm text-red-600"
                                                    id="finished_at-error">{{ campaignErrors.finished_at }}</p>
                                            </div>

                                            <div class="mt-4">
                                                <span class="block text-sm font-medium text-gray-700">Tijdsblok*</span>
                                                    <p class="mt-1 text-sm text-gray-500">
                                                        Kies één tijdsblok waarbinnen de e-mails per dag worden verstuurd.
                                                    </p>
                                                    <div class="mt-2 grid grid-cols-2 gap-2">
                                                        <div
                                                        v-for="block in timeBlocks"
                                                        :key="block.id"
                                                        class="border flex justify-center item-center rounded-md px-3 py-6 cursor-pointer hover:border-lightblue-400"
                                                           :class="{
                                                            'border-lightblue-500 bg-lightblue-50': selectedTimeBlockId === block.id,
                                                            'border-gray-200 bg-white': selectedTimeBlockId !== block.id
                                                        }"
                                                        @click="selectTimeBlock(block)"
                                                    >
                                                            <p class="text-sm text-gray-500">
                                                                {{ block.starting_time }} - {{ block.finished_time }}
                                                            </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mt-4">
                                                <ToggleButton v-model="startForm.weekend_enabled" title="Weekend ingeschakeld" @input="handleWeekendToggle">
                                                    <p class="text-sm text-gray-500">Vink aan om ook in het weekend e-mails te versturen</p>
                                                </ToggleButton>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="startCampaignStep == 2">

                                        <div class="mt-2">
                                            <p class="text-sm text-gray-500">
                                                Kies uit de onderstaande templates welken moeten worden verstuurd
                                                tijdens deze campagne.
                                            </p>
                                            <div class="mt-4">

                                                <div v-for="template, index in templates" :key="index">

                                                    <fieldset class="border-t border-b border-gray-200">
                                                        <legend class="sr-only">Templates</legend>
                                                        <div class=" divide-gray-200" @click="showDingFunc(index)">
                                                            <div class="relative flex items-start py-4">
                                                                <div class="min-w-0 flex-1 text-sm">
                                                                    <label for="comments"
                                                                        class="font-medium text-gray-700">Moeilijkheidsgraad
                                                                        {{ index }}</label>
                                                                    <p id="comments-description" class="text-gray-500">
                                                                        Kies uit de templates met Moeilijkheidsgraad {{ index }}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <div v-if="showDing[index] == true" v-for="temp in template.data"
                                                        :key="temp.id">
                                                        <ToggleButton v-model="startForm.templates[temp.id]"
                                                            :title="temp.name" >
                                                            <span class="text-sm leading-normal text-gray-500">
                                                                Moeilijkheid: {{ temp.difficulty }} / <a
                                                                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
                                                                    target="_blank"
                                                                    :href="temp.links.preview">Voorbeeld</a>
                                                            </span>
                                                        </ToggleButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button v-if="startCampaignStep == 1" type="button"
                                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-lightblue-600 hover:bg-lightblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:ml-3 sm:w-auto sm:text-sm"
                                :disabled="!showButtonFunc()"
                                :class="{ 'pointer-events-none opacity-50': !showButtonFunc() }"
                                @click.prevent="validateAndNext()">
                                Volgende
                            </button>
                            <button v-if="startCampaignStep == 2" type="button"
                                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-lightblue-600 hover:bg-lightblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:ml-3 sm:w-auto sm:text-sm"
                                :disabled="!canStartCampaign"
                                :class="{ 'pointer-events-none opacity-50': !canStartCampaign }"
                                @click="startCampaign()">
                                Start campagne
                            </button>
                            <button v-if="startCampaignStep == 2" @click="startCampaignStep = 1" type="button"
                                class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                                Terug
                            </button>
                            <button v-if="startCampaignStep == 1" @click="createCampaignModal = false" type="button"
                                class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                                Annuleren
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </transition>

        <main v-if="organisation" class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0" @click="closeAllDropdowns">
            <!-- Page title & actions -->
            <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
                <div class="flex-1 min-w-0">
                    <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
                        {{ organisation ? organisation.data.name : 'Organisatie' }}
                    </h1>
                </div>
                <div class="flex mt-4 sm:mt-0 sm:ml-4" v-if="is('BCSA')" >
                    <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
                        <a :href="'/organisations/' + organisation.data.id + '/campaign/start'"
                            class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-lightblue-600 hover:bg-lightblue-500 focus:outline-none focus:shadow-outline-lightblue focus:border-lightblue-700 active:bg-lightblue-700">
                            Campagne starten
                        </a>
                    </span>
                </div>
            </div>
            <!-- Pinned projects -->
            <div class="px-4 mt-6 sm:px-6 lg:px-8">
                <h2 class="text-xs font-medium tracking-wide text-gray-500 uppercase">Scores van
                    {{ organisation ? organisation.data.name : 'Organisatie' }}</h2>
                <ul class="grid grid-cols-1 gap-4 mt-3 sm:gap-6 sm:grid-cols-2 xl:grid-cols-4">
                    <li class="relative flex col-span-1 rounded-md shadow-sm">
                        <div
                            class="flex items-center justify-center flex-shrink-0 w-16 text-sm font-medium leading-5 text-white bg-red-600 rounded-l-md">
                            -
                        </div>
                        <div
                            class="flex items-center justify-between flex-1 truncate bg-white border-t border-b border-r border-gray-200 rounded-r-md">
                            <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                                <a href="#"
                                    class="font-medium text-gray-900 transition duration-150 ease-in-out hover:text-gray-600">
                                    {{ organisation.data.attendeeScores[2] }}
                                </a>
                                <p class="text-gray-500">{{ organisation.data.attendeeScores[3] }}x ingetreden (slechtst)</p>
                            </div>

                        </div>
                    </li>

                    <li class="relative flex col-span-1 rounded-md shadow-sm">
                        <div
                            class="flex items-center justify-center flex-shrink-0 w-16 text-sm font-medium leading-5 text-white bg-green-600 rounded-l-md">
                            +
                        </div>
                        <div
                            class="flex items-center justify-between flex-1 truncate bg-white border-t border-b border-r border-gray-200 rounded-r-md">
                            <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                                <a href="#"
                                    class="font-medium text-gray-900 transition duration-150 ease-in-out hover:text-gray-600">
                                    {{ organisation.data.attendeeScores[0] }}
                                </a>
                                <p class="text-gray-500">{{ organisation.data.attendeeScores[1] }}x ingetreden (beste)</p>
                            </div>

                        </div>
                    </li>

                    <!-- More project cards... -->
                </ul>
            </div>
            <!-- Projects list (only on smallest breakpoint) -->
            <div class="mt-10 sm:hidden">
                <div class="px-4 sm:px-6">
                    <h2 class="text-xs font-medium tracking-wide text-gray-500 uppercase">Campagnes</h2>
                </div>
                <ul class="mt-3 border-t border-gray-200 divide-y divide-gray-100">
                    <li>
                        <a href="#" class="flex items-center justify-between px-4 py-4 hover:bg-gray-50 sm:px-6">
                            <div class="flex items-center space-x-3 truncate">
                                <div class="w-2.5 h-2.5 flex-shrink-0 rounded-full bg-pink-600"></div>
                                <p class="text-sm font-medium leading-6 truncate">GraphQL API <span
                                        class="font-normal text-gray-500 truncate">in Engineering</span></p>
                            </div>
                            <!-- Heroicon name: chevron-right -->
                            <svg class="w-5 h-5 ml-4 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </a>
                    </li>

                    <!-- More project rows... -->
                </ul>
            </div>
            <!-- Projects table (small breakpoint and up) -->
            <div class="hidden mt-8 sm:block">
                <div class="inline-block min-w-full align-middle border-b border-gray-200">
                    <table class="min-w-full">
                        <thead>
                            <tr class="border-t border-gray-200">
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    <span class="lg:pl-2">Deelnemers</span>
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    E-mail
                                </th>
                                <th v-if="is('BCSA')"
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    <span class="lg:pl-2">Groep</span>
                                </th>
                                <th v-if="is('BCSA')"
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    <span class="lg:pl-2">Template Geschiedenis</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-100">
                            <tr v-for="attendee in organisation.data.attendees" :key="attendee.id">
                                <td
                                    class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                                    <div  class="flex items-center space-x-3 lg:pl-2">
                                        <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-green-600"></div>
                                        <input v-if="is('BCSA')" type="checkbox" :key="attendee.id" @change="attendeeCheckbox($event, attendee.id)" />
                                        <div href="#" class="truncate">{{ attendee.name }}</div>
                                    </div>
                                </td>
                                <td class="px-6 py-3 text-sm  font-medium leading-5 text-gray-500">
                                    <div class="flex items-center space-x-2">
                                        <span class="flex-shrink-0 text-xs font-medium leading-5">{{ attendee.email }}</span>
                                    </div>
                                </td>
                                <td v-if="is('BCSA')" class="pr-6">
                                    <div class="relative ml-4">
                                        <button
                                            v-if="!organisationGroups || organisationGroups.length === 0"
                                            @click.stop="openGroupModal"
                                            class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-white border bg-green-600 border-green-500 rounded-md hover:bg-green-500 hover:border-green-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-lightblue-500 transition-colors duration-150"
                                        >
                                            New+
                                        </button>

                                        <div v-else class="relative text-left">
                                            <button
                                                @click.stop="toggleGroups(attendee.id)"
                                                class="flex justify-between min-w-8 w-auto items-center px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-50 border border-gray-300 rounded-md hover:bg-gray-100 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-400 transition-colors duration-150"
                                            >
                                                {{ attendee.group ? attendee.group.name : 'Groep' }}
                                                <svg
                                                    class="w-4 h-4 ml-1.5 transition-transform duration-150"
                                                    :class="{ 'transform rotate-180': groupDropdownOpen[attendee.id] }"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                            </svg>
                                            </button>
                                            <div
                                                v-if="groupDropdownOpen[attendee.id]"
                                                class="absolute top-full left-0 mt-2 w-auto min-w-60 rounded-md shadow-lg border border-gray-500 bg-white z-20 overflow-hidden"
                                            >
                                                <button @click.stop="openGroupModal"
                                                    class="block w-full text-left px-4 py-2 text-xs text-lightgreen-700 bg-green-400 bg-lightgreen-50 hover:bg-green-300">
                                                    New+
                                                </button>
                                                <div class="border-t border-black"></div>
                                                <div class="min-w-60 max-h-40 overflow-y-scroll w-auto pr-2">
                                                    <button v-for="group in organisationGroups" :key="group.id"
                                                        @click.stop="selectGroup(attendee.id, group)" :class="[
                                                            'flex justify-between items-center w-full px-4 py-2 text-xs even:bg-gray-50 hover:bg-gray-200',
                                                            attendee.group && attendee.group.id === group.id ? 'bg-gray-200 font-medium' : 'text-gray-700'
                                                        ]">
                                                        <span class="truncate">
                                                            {{ group.name }}
                                                        </span>

                                                        <button @click.stop.prevent="confirmDeleteGroup(group)"
                                                            class="ml-3 text-red-500 hover:text-red-700 font-bold"
                                                            title="Groep verwijderen">
                                                            X
                                                        </button>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td v-if="is('BCSA')" class="pr-6">
                                    <div class="relative ml-8">
                                        <button @click.stop="toggleTemplateHistory(attendee.id)"
                                            class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-50 border border-gray-300 rounded-md hover:bg-gray-100 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-400 transition-colors duration-150">
                                            Geschiedenis
                                            <svg class="w-4 h-4 ml-1.5 transition-transform duration-150" :class="{'transform rotate-180': showTemplateHistory[attendee.id]}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                            </svg>
                                        </button>
                                        <div v-if="showTemplateHistory[attendee.id]" class="absolute left-0 z-10 w-80 mt-2 bg-white border border-gray-200 rounded-md shadow-lg">
                                            <div class="p-4">
                                                <h4 class="text-sm font-medium text-gray-900 mb-2">Template Geschiedenis</h4>
                                                <div v-if="attendee.template_history && attendee.template_history.length > 0" class="space-y-2 max-h-64 overflow-y-auto pr-2">
                                                    <div v-for="history in attendee.template_history" :key="history.send_at" class="border-b border-gray-100 pb-2 last:border-b-0">
                                                        <div class="flex justify-between items-start">
                                                            <div class="flex-1">
                                                                <div class="font-medium text-sm text-gray-900">{{ history.template_name }}</div>
                                                                <div class="text-xs text-gray-500">{{ history.campaign_name }}</div>
                                                                <div class="text-xs text-gray-400 mt-1">
                                                                    Verzonden: {{ history.send_at ? new Date(history.send_at).toLocaleDateString('nl-NL') + ' ' + new Date(history.send_at).toLocaleTimeString('nl-NL', {hour: '2-digit', minute:'2-digit'}) : '-' }}
                                                                </div>
                                                            </div>
                                                            <div class="flex flex-col items-end space-y-1">
                                                                <span v-if="history.opened_at" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                                    Geopend
                                                                </span>
                                                                <span v-if="history.clicked_at" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                                                    Geklikt
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="text-sm text-gray-500">
                                                    Geen template geschiedenis beschikbaar
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <span v-if="('BCSA')" class="inline-flex ml-6 rounded-md shadow-sm mt-4">
                    <button v-if="showDeleteUsers()"
                        @click="deleteSelectedUsers()"
                        class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-lightblue-600 hover:bg-lightblue-500 focus:outline-none focus:border-lightblue-700 focus:shadow-outline-lightblue active:bg-lightblue-700">
                        Verwijder deelnemers
                    </button>
                    <p class="mt-1 text-md text-green-500" id="file_input_help">{{ $page.props.flash.success2 }}</p>
                </span>

                <p v-if="groupSuccessMessage" class="text-green-600 ml-5">
                    {{ groupSuccessMessage }}
                </p>

                <p v-if="groupErrorMessage" class="text-red-600 ml-5">
                    {{ groupErrorMessage }}
                </p>

                <div v-if="is('BCSA')" class="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">

                    <div>
                        <div class="pt-8 space-y-6 sm:pt-10 sm:space-y-5">
                            <div>
                                <h3 class="text-lg font-medium leading-6 text-gray-900">
                                    Deelnemer toevoegen
                                </h3>
                                <p class="max-w-2xl mt-1 text-sm text-gray-500">
                                    De volgende informatie wordt gebruikt, voor het opstellen van een campagne.
                                </p>
                            </div>
                            <div class="space-y-6 sm:space-y-5">
                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                    <label for="attendee_name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                        Naam
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input type="text" id="attendee_name" placeholder="Naam" v-model="attendeeForm.name"
                                            :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.name }"
                                            class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                                        <p v-if="errors.email" class="mt-2 text-sm text-red-600" id="email-error">{{
                                                errors.name
                                        }}</p>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                    <label for="attendee_email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                        E-mailadres
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input type="email" id="attendee_email" placeholder="naam@domein.nl"
                                            v-model="attendeeForm.email"
                                            :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.email }"
                                            class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                                        <p v-if="errors.email" class="mt-2 text-sm text-red-600" id="email-error">{{
                                                errors.email
                                        }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pt-5 mt-8 border-t border-gray-200">
                        <div class="flex justify-end">

                            <span class="inline-flex ml-3 rounded-md shadow-sm">
                                <button @click="saveAttendee()"
                                    class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-lightblue-600 hover:bg-lightblue-500 focus:outline-none focus:border-lightblue-700 focus:shadow-outline-lightblue active:bg-lightblue-700">
                                    Deelnemer toevoegen
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="is('BCSA')" >
                    <div class="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                        <div>
                            <div class="pt-8 space-y-6 sm:pt-10 sm:space-y-5">
                                <div>
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        Deelnemers toevoegen via bestand
                                    </h3>
                                    <div class="flex mt-1 text-sm justify-between items-center" >
                                        <p class=" text-gray-500">
                                            Hieronder kan je doormiddel van een <b>.CSV</b> bestand deelnemers toevoegen.
                                        </p>
                                        <a href="/attendee/template/download" class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 whitespace-nowrap">
                                            Download template CSV
                                        </a>
                                    </div>
                                    <div class="mt-4" >
                                        <form method="post" >
                                            <input required class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none p-3" aria-describedby="file_input_help" id="file_input" type="file" v-on:change="handleFilesUpload( $event )">
                                            <p class="mt-1 text-sm text-gray-500" id="file_input_help">Alleen een .CSV</p>
                                            <p class="mt-1 text-md text-red-500" id="file_input_help">{{ $page.props.flash.error }}</p>
                                            <div class="flex justify-end">
                                                <button type="button" v-if="hasFile == true" v-on:click="submitFiles()" class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-lightblue-600 hover:bg-lightblue-500 focus:outline-none focus:border-lightblue-700 focus:shadow-outline-lightblue active:bg-lightblue-700" >Deelnemers toevoegen</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
           
           
                        </div>
                    </div>
                </div>
                <div v-if="is('BCSA')" class="inline-block min-w-full align-middle border-b border-gray-200">
                    <table class="min-w-full">
                        <thead>
                            <tr class="border-t border-gray-200">
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    <span class="lg:pl-2">Beheerder</span>
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    E-mail
                                </th>
                                <th class="py-3 pr-6 text-xs font-medium leading-4 tracking-wider text-right text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-100">
                            <tr v-for="customer in organisation.data.customers" :key="customer.id">
                                <td
                                    class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                                    <div  class="flex items-center space-x-3 lg:pl-2">
                                        <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-green-600"></div>
                                        <div href="#" class="truncate">{{ customer.name }}</div>
                                    </div>
                                </td>
                                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                                    <div class="flex items-center space-x-2">
                                        <span class="flex-shrink-0 text-xs font-medium leading-5">{{ customer.email }}</span>
                                    </div>
                                </td>
                                <td class="pr-6">
                                    <div class="relative flex items-center justify-end">
                                        <a @click="deleteCustomer(customer)"
                                            class="flex items-center px-4 py-2 text-sm leading-5 text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                            role="menuitem">
                                            <svg class="w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                fill="currentColor">
                                                <path fill-rule="evenodd"
                                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            Verwijder
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="is('BCSA')" >
                    <div class="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                        <div>
                            <div class="pt-8 space-y-6 sm:pt-10 sm:space-y-5">
                                <div>
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        Klantbeheerder toevoegen
                                    </h3>
                                    <div class="flex max-w-2xl mt-1 text-sm" >
                                        <p class=" text-gray-500">
                                            Hieronder kan je een account aanmaken voor een klantbeheerder.
                                        </p>
                                    </div>
                                    <div class="mt-4" >
                                        <div class="space-y-6 sm:space-y-5">
                                            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                <label for="customer_name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                    Naam
                                                </label>
                                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                    <input type="text" id="customer_name" placeholder="Mees van Herk" v-model="customerOwnerForm.name"
                                                        :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.name }"
                                                        class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                                                    <p v-if="errors.email" class="mt-2 text-sm text-red-600" id="email-error">{{
                                                            errors.name
                                                    }}</p>
                                                </div>
                                            </div>

                                            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                <label for="customer_email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                    E-mailadres
                                                </label>
                                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                    <input type="email" id="customer_email" placeholder="naam@domein.nl"
                                                        v-model="customerOwnerForm.email"
                                                        :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.email }"
                                                        class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                                                    <p v-if="errors.email" class="mt-2 text-sm text-red-600" id="email-error">{{
                                                            errors.email
                                                    }}</p>
                                                </div>
                                            </div>


                                            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                <label for="customer_password" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                    Wachtwoord
                                                </label>
                                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                    <input type="password" id="customer_password" placeholder="********"
                                                        v-model="customerOwnerForm.password"
                                                        :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.password }"
                                                        class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                                                    <p v-if="errors.password" class="mt-2 text-sm text-red-600" id="password-error">{{
                                                            errors.password
                                                    }}</p>
                                                </div>
                                            </div>

                                            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                <label for="customer_password_confirmation" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                    Bevestig Wachtwoord
                                                </label>
                                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                    <input type="password" id="customer_password_confirmation" placeholder="********"
                                                        v-model="customerOwnerForm.password_confirmation"
                                                        :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.password_confirm }"
                                                        class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                                                    <p v-if="errors.password_confirmation" class="mt-2 text-sm text-red-600" id="password_confirmation-error">{{
                                                            errors.password_confirmation
                                                    }}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-5 mt-8 border-t border-gray-200">
                        <div class="flex justify-end">

                            <span class="inline-flex ml-3 rounded-md shadow-sm">
                                <button @click="saveCustomer()"
                                    class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-lightblue-600 hover:bg-lightblue-500 focus:outline-none focus:border-lightblue-700 focus:shadow-outline-lightblue active:bg-lightblue-700">
                                    Beheerder toevoegen
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <p v-if="campaignErrors.templates" class="mt-2 text-sm text-red-600" id="templates-error">{{ campaignErrors.templates }}</p>
            </div>
        </div>
                <div class="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div>
                        <div class="pt-8 space-y-6 sm:pt-10 sm:space-y-5">
                            <div>
                                <h3 class="text-lg font-medium leading-6 text-gray-900">
                                    Campagnes
                                </h3>
                                <div class="flex max-w-2xl mt-1 text-sm" >
                                    <p class=" text-gray-500">
                                        Hieronder volgen alle campagnes van
                                    </p>
                                    <p class="text-gray-600 ml-1" >
                                        {{ organisation ? organisation.data.name : 'Organisatie' }}
                                    </p>
                                </div>
                            </div>
                            <div class="hidden mt-8 sm:block">
                                <div class="inline-block min-w-full align-middle border-b border-gray-200">
                                <table class="min-w-full">
                                    <thead>
                                    <tr class="border-t border-gray-200">
                                        <th
                                        class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                        <span class="lg:pl-2">Campagnes</span>
                                        </th>
                                        <th
                                        class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                        Start op
                                        </th>
                                        <th
                                        class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                        Eindigt op
                                        </th>
                                        <th
                                        class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:table-cell bg-gray-50">
                                        Pogingen per deelnemer
                                        </th>
                                     </tr>
                                     </thead>
                                     <tbody class="bg-white divide-y divide-gray-100">
                                     <tr class="hover:bg-gray-100" v-for="campaign in campaigns.data" :key="campaign.id">
                                        <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                                        <div class="flex items-center space-x-3 lg:pl-2">
                                            <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-red-600" :class="{'bg-green-600' : campaign.hasEnded }" ></div> 
                                            <a :href="'/campaign/' + campaign.id + ''" class="truncate hover:text-gray-600"> 
                                            <span>Campagne<span class="font-normal text-gray-500">
                                            </span> </span> 
                                            </a> 
                                        </div>
                                        </td>
                                        <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                                        {{ campaign.starting_at }}
                                        </td>
                                        <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                                        {{ campaign.finished_at }}
                                        </td>
                                        <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                                        {{ campaign.attempts_per_user }}
                                        </td>
                                     </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Modal from '@/Shared/Modal';
import ToggleButton from '@/Shared/ToggleButton';
import axios from 'axios';

export default {
	components: {
		Layout,
		Modal,
		ToggleButton,
	},
	props: {
		errors: Object,
		organisation: Object,
		templates: Object,
		campaigns: Object,
		error: String,
		success: String,
		success2: String,
		message: String,
	},
	data: () => ({
		successModal: false,
		startCampaignStep: 1,
		createCampaignModal: false,
		showCreateAttendeeModal: false,
		showCreateCampaignModal: false,
		attendeeOptionDropdownId: null,
        groupSuccessMessage: null,
        groupErrorMessage: null,
        groupErrors: {},

		removeBtn: false,
		showTemplateHistory: {},
		showDing: {
			1: false,
			2: false,
			3: false,
			4: false,
		},
		startForm: {
			organisation_id: null,
			click_notification: null,
			attempts_per_user: null,
			starting_at: null,
			starting_time: null,
			finished_at: null,
			finished_time: null,
			weekend_enabled: false,
			templates: []
		},
		attendeeForm: {
			name: null,
			email: null,
			phone: null,
		},
		customerOwnerForm: {
			name: null,
			email: null,
			password: null,
			password_confirmation: null,
			organisation_id: null,
		},
		files: '',
		giveId: {
			id: null,
		},
		hasFile: false,
		attenToDel: [],
		localCampaignErrors: {},
        timeBlocks: [
			{ id: 1, starting_time: '07:00', finished_time: '16:00' },
			{ id: 2, starting_time: '07:30', finished_time: '16:30' },
			{ id: 3, starting_time: '08:00', finished_time: '17:00' },
			{ id: 4, starting_time: '08:30', finished_time: '17:30' },
		],
		selectedTimeBlockId: null,
		
		showGroupModal: false,
		newGroupName: '',
		groupDropdownOpen: {},
	}),
	computed: {
		organisationGroups() {
			if (!this.organisation || !this.organisation.data || !this.organisation.data.groups) {
				return [];
			}
			return Array.isArray(this.organisation.data.groups) 
				? this.organisation.data.groups 
				: Object.values(this.organisation.data.groups);
		},
		campaignErrors(){
			const allowed = ['attempts_per_user','starting_at','starting_time','finished_at','finished_time','click_notification','templates'];
			const serverErrors = this.errors || {};
			const filtered = {};
			allowed.forEach(k => { if (serverErrors[k]) filtered[k] = serverErrors[k]; });
			return Object.assign({}, filtered, this.localCampaignErrors || {});
		},
		minDate() {
			return new Date().toISOString().split('T')[0];
		},
		canStartCampaign() {
			const selectedCount = Object.values(this.startForm.templates).filter(v => v).length;
			return selectedCount === parseInt(this.startForm.attempts_per_user);
		}
	},
	methods: {
        selectTimeBlock(block) {
			this.selectedTimeBlockId = block.id;
			this.startForm.starting_time = block.starting_time;
			this.startForm.finished_time = block.finished_time;
			this.validateForm();
		},
		isWeekend(dateString) {
			if (!dateString) return false;
			const date = new Date(dateString);
			const day = date.getDay();
			return day === 0 || day === 6;
		},
		handleWeekendToggle() {
			this.validateWeekendDates();
		},
		validateWeekendDates() {
			const fields = ['starting_at', 'finished_at'];
			fields.forEach(field => {
				const dateValue = this.startForm[field];
				if (dateValue && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
					if (!this.startForm.weekend_enabled && this.isWeekend(dateValue)) {
						this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { [field]: 'Weekend datums zijn uitgeschakeld. Selecteer een werkdag.' });
					} else {
						if (this.localCampaignErrors && this.localCampaignErrors[field] && this.localCampaignErrors[field].includes('Weekend datums')) {
							const { [field]: removed, ...rest } = this.localCampaignErrors;
							this.localCampaignErrors = rest;
						}
					}
				}
			});
		},
		handleDateValidation(field) {
			const dateValue = this.startForm[field];
			if (dateValue && /^\d{4}-\d{2}-\d{2}$/.test(dateValue) && !this.startForm.weekend_enabled && this.isWeekend(dateValue)) {
				this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { [field]: 'Weekend datums zijn uitgeschakeld. Selecteer een werkdag.' });
			} else if (dateValue && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
				if (this.localCampaignErrors && this.localCampaignErrors[field] && this.localCampaignErrors[field].includes('Weekend datums')) {
					const { [field]: removed, ...rest } = this.localCampaignErrors;
					this.localCampaignErrors = rest;
				}
			}
			this.validateDateOrder();
			this.validateWeekendDates();
		},
		validateDateOrder() {
			if (this.startForm.starting_at && this.startForm.starting_time && this.startForm.finished_at && this.startForm.finished_time) {
				if (!this.isDateOrderValid()) {
					this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { finished_at: 'Einddatum en -tijd moeten na startdatum en -tijd liggen.' });
				} else {
					if (this.localCampaignErrors && this.localCampaignErrors.finished_at && this.localCampaignErrors.finished_at.includes('Einddatum en -tijd')) {
						const { finished_at, ...rest } = this.localCampaignErrors;
						this.localCampaignErrors = rest;
					}
				}
			}
		},

		attendeeCheckbox(event, id){
			if(!(this.attenToDel.includes(id))){
				this.attenToDel = [...this.attenToDel, id];
				return
			}
			this.attenToDel = this.attenToDel.filter(item => item !== id);
			return

		},
		deleteSelectedUsers(){

			let form = {
				users: this.attenToDel,
			}

			if(confirm('Weet je zeker dat je deze deelnemers wilt verwijderen?')){
				this.attenToDel = [];
				this.$inertia.post('/attendee/massdelete', form);
			}

			
		},
		showDeleteUsers(){
			return this.attenToDel.length >= 1;
		},
		submitFiles(){
			let formData = new FormData();

			this.giveId.id = this.organisation.data.id

			for(let i = 0; i < this.files.length; i++){
				let file = this.files[i];

				formData.append('file', file);
				formData.append('id', this.organisation.data.id);	  
			}

			this.$inertia.post('/organisations/addusers', formData,
					{ 
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			)
		},
		handleFilesUpload(event){
			this.files = event.target.files;
			this.hasFile = true;
		},

		showButtonFunc(){
			return this.startCampaignStep == 1 &&
				   this.startForm.attempts_per_user != null &&
				   this.startForm.attempts_per_user > 0 &&
				   this.startForm.starting_at != null &&
				   this.startForm.starting_time != null &&
				   this.startForm.finished_at != null &&
				   this.startForm.finished_time != null &&
				   this.isStartInFuture() &&
				   this.isDateOrderValid();
		},
		isStartInFuture(){
			try {
				if (!this.isValidYmd(this.startForm.starting_at) || !this.startForm.starting_time) {
					return false;
				}
				const start = new Date(`${this.startForm.starting_at}T${this.startForm.starting_time}`);
				const now = new Date();
				if (isNaN(start.getTime())) {
					return false;
				}
				return start.getTime() >= now.getTime();
			} catch (e) {
				return false;
			}
		},
		isDateOrderValid(){
			try {
				if (!this.isValidYmd(this.startForm.starting_at) || !this.startForm.starting_time) { return false; }
				if (!this.isValidYmd(this.startForm.finished_at) || !this.startForm.finished_time) { return false; }
				if (this.startForm.starting_at === this.startForm.finished_at) { return false; } // Same day not allowed
				const start = new Date(`${this.startForm.starting_at}T${this.startForm.starting_time}`);
				const end = new Date(`${this.startForm.finished_at}T${this.startForm.finished_time}`);
				if (isNaN(start.getTime()) || isNaN(end.getTime())) {
					return false;
				}
				return end > start;
			} catch (e) {
				return false;
			}
		},
		isValidYmd(value){
			return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
		},
		validateForm(){
			if (this.startForm.starting_at && this.startForm.starting_time && this.startForm.finished_at && this.startForm.finished_time) {
				if (!this.isDateOrderValid()) {
					this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { finished_at: 'Einddatum en -tijd moeten na startdatum en -tijd liggen.' });
				} else if (this.localCampaignErrors && this.localCampaignErrors.finished_at) {
					const { finished_at, ...rest } = this.localCampaignErrors;
					this.localCampaignErrors = rest;
				}

				if (this.startForm.starting_at === this.startForm.finished_at && this.startForm.finished_time <= this.startForm.starting_time) {
					this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { finished_time: 'Eind tijd moet na de start tijd zijn.' });
				} else if (this.localCampaignErrors && this.localCampaignErrors.finished_time) {
					const { finished_time, ...rest } = this.localCampaignErrors;
					this.localCampaignErrors = rest;
				}
			}

			if (this.startForm.starting_at && this.startForm.starting_time) {
				if (!this.isStartInFuture()) {
					this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { starting_at: 'Startdatum en -tijd mogen niet in het verleden liggen.' });
				} else if (this.localCampaignErrors && this.localCampaignErrors.starting_at) {
					const { starting_at, ...rest2 } = this.localCampaignErrors;
					this.localCampaignErrors = rest2;
				}
			}

			if (this.showButtonFunc()) {
				this.startForm.organisation_id = this.organisation.data.id;
				axios.post('/campaign/validate', this.startForm)
					.then(() => {
						this.localCampaignErrors = {};
					})
					.catch((error) => {
						if (error && error.response && error.response.status === 422) {
							this.localCampaignErrors = error.response.data.errors || {};
						}
					});
			}
		},
		validateAndNext(){
			if (!this.showButtonFunc()) {
				this.validateForm();
				return;
			}
			if (!this.isDateOrderValid()) {
				this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { finished_at: 'Einddatum en -tijd moeten na startdatum en -tijd liggen.' });
				return;
			}
			if (!this.isStartInFuture()) {
				this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { starting_at: 'Startdatum en -tijd mogen niet in het verleden liggen.' });
				return;
			}
			if (this.campaignErrors && Object.keys(this.campaignErrors).length > 0) {
				console.log('Cannot proceed - validation errors exist:', this.errors);
				return;
			}
			this.startCampaignStep = 2;
		},
		showButtonFunc(){
			return this.startCampaignStep == 1 &&
			       this.startForm.attempts_per_user != null &&
			       this.startForm.attempts_per_user > 0 &&
			       this.startForm.starting_at != null &&
			       this.startForm.starting_time != null &&
			       this.startForm.finished_at != null &&
			       this.startForm.finished_time != null;
		},
		validateForm(){
			const now = new Date();
			const today = now.toISOString().split('T')[0];
			const currentTime = now.toTimeString().split(' ')[0].substring(0, 5);
			const startDate = this.startForm.starting_at;
			const startTime = this.startForm.starting_time;
			const endDate = this.startForm.finished_at;
			
			this.errors = this.errors || {};
			
			if (startDate && startDate < today) {
				this.$set(this.errors, 'starting_at', 'Start datum moet vandaag of in de toekomst zijn');
			} else if (startDate === today && startTime && startTime <= currentTime) {
				this.$set(this.errors, 'starting_time', 'Start tijd moet in de toekomst zijn');
			} else {
				this.$delete(this.errors, 'starting_at');
				this.$delete(this.errors, 'starting_time');
			}
			
			if (endDate && startDate && endDate <= startDate) {
				this.$set(this.errors, 'finished_at', 'Eind datum moet na de start datum zijn');
			} else {
				this.$delete(this.errors, 'finished_at');
			}
			
			if (this.startForm.attempts_per_user && this.startForm.attempts_per_user <= 0) {
				this.$set(this.errors, 'attempts_per_user', 'Aantal e-mails moet groter dan 0 zijn');
			} else {
				this.$delete(this.errors, 'attempts_per_user');
			}
		},
		toggleTemplateHistory(attendeeId) {
			const isCurrentlyOpen = !!this.showTemplateHistory[attendeeId];
			this.showTemplateHistory = {};
			this.groupDropdownOpen = {};
			if (!isCurrentlyOpen) {
				this.$set(this.showTemplateHistory, attendeeId, true);
			}
		},
		showDingFunc(index) {
			this.$set(this.showDing, index, !this.showDing[index]);
		},
		closeAllDropdowns() {
			this.showTemplateHistory = {};
			this.groupDropdownOpen = {};
		},
		startCampaign() {
			this.startForm.organisation_id = this.organisation.data.id;

			const selectedCount = Object.values(this.startForm.templates).filter(v => v).length;
			if (selectedCount != parseInt(this.startForm.attempts_per_user)) {
				this.localCampaignErrors = Object.assign({}, this.localCampaignErrors, { templates: 'Selecteer precies ' + this.startForm.attempts_per_user + ' templates.' });
				return;
			} else {
				if (this.localCampaignErrors && this.localCampaignErrors.templates) {
					const { templates, ...rest } = this.localCampaignErrors;
					this.localCampaignErrors = rest;
				}
			}

			this.$inertia.post('/campaign', this.startForm,  {
				onSuccess: (page) => {
					console.log(page);
					this.showCreateCampaignModal = false;
					this.createCampaignModal = false;
					this.startCampaignStep = 1;
					this.successModal = true;

                    this.startForm = {
                        organisation_id: null,
                        click_notification: null,
                        attempts_per_user: null,
                        starting_at: null,
                        starting_time: null,
                        finished_at: null,
                        finished_time: null,
                        weekend_enabled: false,
                        templates: []
                    };

                    setTimeout(() => {
                        this.showCreateCampaignModal = false;
                        this.successModal = false;
                    }, 5000);
                },
                onError: (errors) => {
                    console.log('Validation errors:', errors);
                    this.startCampaignStep = 1;
                    this.createCampaignModal = true;
                },
            });
        },
		openGroupModal() {
			this.groupErrors = {};
			this.groupSuccessMessage = null;
			this.groupErrorMessage = null;
			this.showGroupModal = true;
		},
		closeGroupModal() {
			this.showGroupModal = false;
			this.newGroupName = '';
			this.groupErrors = {};
			this.groupSuccessMessage = null;
			this.groupErrorMessage = null;
		},
        createGroup() {
            const name = this.newGroupName?.trim();
            if (!name) return;
            this.groupErrors = {};
            this.groupSuccessMessage = null;
            this.groupErrorMessage = null;

            const existingGroup = this.organisationGroups.find(
                group => group.name.toLowerCase().trim() === name.toLowerCase().trim()
            );

            if (existingGroup) {
                this.groupErrors = { name: 'Een groep met deze naam bestaat al binnen deze organisatie.' };
                this.groupErrorMessage = 'Een groep met deze naam bestaat al binnen deze organisatie.';
                return;
            }

            const organisationId = this.organisation.data.id;

            this.$inertia.post(
                `/organisations/${organisationId}/groups`,
                { name },
                {
                    preserveState: true,
                    preserveScroll: true,

                    onSuccess: () => {
                        if (!this.groupErrors || Object.keys(this.groupErrors).length === 0) {
                            this.groupSuccessMessage = 'Groep succesvol aangemaakt';
                        }
                        this.groupErrorMessage = null;
                        this.groupErrors = {};
                        this.newGroupName = '';
                        this.showGroupModal = false;
                        setTimeout(() => {
                            this.groupSuccessMessage = null;
                        }, 3000);
                    },

                    onError: (errors) => {
                        let nameError = null;
                        if (errors && errors.name) {
                            nameError = Array.isArray(errors.name) ? errors.name[0] : errors.name;
                        }
                        
                        this.groupErrors = nameError ? { name: nameError } : {};
                        this.groupErrorMessage = nameError ?? 'Er ging iets mis';
                        this.groupSuccessMessage = null;
                    },
                }
            );
        },

		toggleGroups(attendeeId) {
			const isCurrentlyOpen = !!this.groupDropdownOpen[attendeeId];
			this.groupDropdownOpen = {};
			this.showTemplateHistory = {};
			if (!isCurrentlyOpen) {
				this.$set(this.groupDropdownOpen, attendeeId, true);
			}
		},
		selectGroup(attendeeId, group) {
			const organisationId = this.organisation && this.organisation.data ? this.organisation.data.id : null;
			if (!organisationId) {
				return;
			}

			this.$inertia.post(`/organisations/${organisationId}/attendees/group`, {
				attendee_id: attendeeId,
				organisation_group_id: group.id,
			}, {
                preserveState: true,
                preserveScroll: true,
				onSuccess: () => {
					this.$set(this.groupDropdownOpen, attendeeId, false);
				},
            });
        },
        saveAttendee() {
            this.attendeeForm.organisation_id = this.organisation.data.id;
            if (this.attendeeForm.name != null && this.attendeeForm.email != null) {
                this.$inertia.post('/attendee', this.attendeeForm, {
                    onSuccess: () => {
                        const flash = this.$page.props && this.$page.props.flash ? this.$page.props.flash : {};
                        if (flash.success) {
                            this.showCreateAttendeeModal = true;
                            this.attendeeForm = { name: null, email: null, phone: null };
                            setTimeout(() => {
                                this.showCreateAttendeeModal = false;
                            }, 5000);
                        }
                    },
                    onError: () => {
                    },
                });
            }
        },
        deleteAttendee(attendee) {
            if (confirm("Weet je zeker dat je deze deelnemer wilt verwijderen?")) {
                this.$inertia.delete(attendee.links.delete_attendee);
            }
        },
        saveCustomer() {
            this.customerOwnerForm.organisation_id = this.organisation.data.id;
            if(this.customerOwnerForm.name != null &&
                this.customerOwnerForm.email != null &&
                this.customerOwnerForm.password != null &&
                this.customerOwnerForm.password_confirmation != null
              ){
                this.$inertia.post('/customerOwner', this.customerOwnerForm, {
                    onFinish: () => {
                        const hasErrors = this.errors && Object.keys(this.errors).length > 0;
                        if (!hasErrors) {
                            this.customerOwnerForm = { name: null, email: null, password: null, password_confirmation: null };
                        }
                    },
                })
            }
        },
        deleteCustomer(customer) {
            console.log(customer.links.delete_customer)
            if (confirm("Weet je zeker dat je deze beheerder wilt verwijderen?")) {
                this.$inertia.delete(customer.links.delete_customer);
            }
        },
        confirmDeleteGroup(group) {
            if (!group || !group.id) return;

            if (confirm('Weet je zeker dat je deze groep wilt verwijderen?')) {
                const organisationId = this.organisation.data.id;

                this.$inertia.delete(
                    `/organisations/${organisationId}/groups/${group.id}`,
                    {
                        preserveState: true,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.groupDropdownOpen = {};
                        },
                    }
                );
            }
        },
	},
	watch: {
		errors: {
			handler(newErrors) {
				if (this.showGroupModal && newErrors && newErrors.name) {
					const errorText = Array.isArray(newErrors.name) ? newErrors.name[0] : newErrors.name;
					if (errorText && (errorText.includes('groep') || errorText.includes('Een groep'))) {
						if (!this.groupErrors.name || this.groupErrors.name !== errorText) {
							this.groupErrors = { name: errorText };
							this.groupErrorMessage = errorText;
							this.groupSuccessMessage = null;
						}
						if (this.errors && this.errors.name) {
							this.$delete(this.errors, 'name');
						}
					}
				}
			},
			deep: true,
			immediate: false
		}
	}
}
</script>
